import React from 'react';
import cn from 'clsx';
import styles from './index.module.scss';
import Card from '@components-clean/core/card';
import { bankersRound } from '@components-clean/core/charts/shared/number-utils';

const colorClasses = [styles.colorBlue, styles.colorSky, styles.colorPurple];

export type DataListingProgressCardRow = {
    id: string;
    name: string;
    reviewedCount: number;
};

type Props = {
    title: string;
    rows: DataListingProgressCardRow[];
    totalCount: number;
};

const computePercent = (reviewed: number, total: number) => {
    if (total <= 0) return 0;
    const safeReviewed = Math.max(0, Math.min(reviewed, total));
    return (safeReviewed / total) * 100;
};

const DataListingProgressCard = ({ title, rows, totalCount }: Props) => {
    return (
        <Card data-testid="data-listing-progress-card" bodyClassName={styles.cardBody} title={title}>
            {rows.map((item, i) => {
                const safeReviewedCount = Math.min(item.reviewedCount, totalCount);
                const percent = bankersRound(computePercent(safeReviewedCount, totalCount), 2);
                const colorClass = colorClasses[i % colorClasses.length];

                return (
                    <div key={item.id} className={styles.row}>
                        <div className={styles.rowLabel}>
                            {item.name} {percent}% Reviewed
                        </div>

                        <div
                            className={styles.breakdownBar}
                            role="progressbar"
                            aria-valuenow={safeReviewedCount}
                            aria-valuemin={0}
                            aria-valuemax={totalCount}
                            aria-label={item.name}
                        >
                            <div className={cn(styles.breakdownFill, colorClass)} style={{ width: `${percent}%` }} />
                        </div>
                    </div>
                );
            })}
        </Card>
    );
};

export default DataListingProgressCard;
